var _polygon, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationCircleGrayscale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.6 24.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Exclamation Circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "exclamationcircleNeutral4Grayscale",
    points: "17 .9 8.5 3 3.2 8.7 3.2 16.9 8.5 22.1 17.6 23.5 17 24 7.8 24 .9 16.9 .9 7.7 7.3 .9 17 .9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4,
    cy: 18.2,
    r: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8,5.2c.5,0,.9.4.9.9l-.3,9c0,.5-.4.9-.9.9h-.3c-.5,0-.9-.4-.9-.9l-.4-9c0-.5.4-.9.9-.9,0,0,1,0,1,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9,1.2l6.5,6.5v9.2l-6.5,6.5H7.7l-6.5-6.5V7.7L7.7,1.2h9.2M17.4,0H7.2L0,7.2v10.2l7.2,7.2h10.2l7.2-7.2V7.2L17.4,0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircleGrayscale);
export default __webpack_public_path__ + "static/media/exclamation-circle-grayscale.4f14fca10ef0f46cc06e1584db0b2bae.svg";
export { ForwardRef as ReactComponent };